import { OMY_SETTING, OmyConst } from "../../OmyConst";
import OMath from "../../utils/OMath";
import Omy from "../../Omy";
import OMultiStyleTextFont from "./OMultiStyleTextFont";

export default class OMultiStyleTextNumberFont extends OMultiStyleTextFont {
    constructor(text, style, canvas) {
        super(text, style, canvas);

        this._oType = OmyConst.OMY_MULTI_STYLE_TEXT_NUMBER_FONT;

        this._value = "0";
        this._valueBuffer = null;
        this._dollar = null;
        this._cent = null;

        this._newValue = null;
        this._incSecond = 0;
        this._onCompleteInc = null;
        this._onStepInc = null;
        this._soundInc = null;

        this._specSymbol = null;

        this._zeroZeroType = style.hasOwnProperty("zeroZeroType") ? style["zeroZeroType"] : true;

        this._showCent = style.hasOwnProperty("showCent") ? style["showCent"] : OMY_SETTING.TEXT_NUMBER_SHOW_CENT;

        this._hideIfZero = style.hasOwnProperty("hideIfZero") ? style["hideIfZero"] : false;
        this._delaySymbol = style.hasOwnProperty("delaySymbol") ? style["delaySymbol"] : ".";
        this._simpleZero = style.hasOwnProperty("simpleZero") ? style["simpleZero"] : false;

        this._needNumberSpace = style.hasOwnProperty("needNumberSpace") ? style["needNumberSpace"] : false;

        this._lastText = style.hasOwnProperty("lastText") ? style["lastText"] : "";
        this._firstText = style.hasOwnProperty("firstText") ? style["firstText"] : "";

        if (!text.length) text = this._value;
        this.setNumbers(text);
    }

    /**
     * @param {Number}value
     * @param {Boolean}incAnimNow
     * @param {String}ease default='Power0.easeNone'
     */
    setNumbers(value, incAnimNow = false, ease = null) {

        if (value < 0) {
            this._value = "0";
            this.createText();
        } else {
            value = OMath.roundNumber(value, 100);
            if (incAnimNow) {
                if (Number(this._value) !== value) {
                    if (this._tween) {
                        this._tween.kill();
                        this._tween = null;
                    }

                    this._tweenValue = this.value;
                    this._newValue = String(OMath.roundNumber(value, 100));
                    ease = ease || "Power0.easeNone";
                    this._tween = Omy.add.tween(
                        this, { _tweenValue: OMath.roundNumber(value, 100) },
                        this._incSecond, this._onFinishInc.bind(this),
                        {
                            onUpdate: this._onIncUpdate.bind(this),
                            ease: ease
                        });
                } else {
                    if (this._onCompleteInc)
                        this._onCompleteInc(this);
                }

                return;
            }

            if (this._tween) {
                this._tween.kill();
                this._tween = null;
            }
            this._value = String(value);
            this.createText();
        }

        this.updateNumbers();
    }

    /**     * @private     */
    _onFinishInc() {
        this._tween = null;
        if (this._onCompleteInc)
            this._onCompleteInc(this);
    }

    /**     * @private     */
    _onIncUpdate() {
        this._value = String(OMath.roundNumber(this._tweenValue, 100));
        this.createText();
        this.updateNumbers();
        if (this._onStepInc)
            this._onStepInc(this._value);
    }

    createText() {
        let valueString = this._value.split(".");
        if (this._zeroZeroType)
            valueString[1] = (valueString.length === 1) ? "00" : (valueString[1].length === 1) ? valueString[1] + "0" : valueString[1];
        else
            valueString[1] = (valueString.length === 1) ? "" : (valueString[1].length === 1) ? valueString[1] + "0" : valueString[1];
        this._dollar = this._needNumberSpace ? OMath.convertNumb(Number(valueString[0])) : valueString[0];
        this._cent = valueString[1];
        if (this._simpleZero)
            this._cent = "";
        valueString.length = 0;
        valueString = null;
    }

    updateNumbers() {
        if (this._cent.length > 0 && this._cent.length <= 2)
            this._cent = this._delaySymbol + this._cent;
        this.text = this._firstText + this._dollar + ((this._showCent) ? this._cent : "") + this._lastText;

        if (this._hideIfZero) {
            if (this.value === 0 && this.visible)
                this.visible = false;
            else if (!this.visible && this.value !== 0)
                this.visible = true;
        }

        if (this._specSymbol) {
            this._specSymbol.x = this.x + this.width * Math.abs(this.anchorX - 1);
        }
    }

    kill() {
        if (this._tween) {
            this._tween.kill();
            this._tween = null;
        }
        return super.kill();
    }

    destroy() {
        this._value = null;
        this._dollar = null;
        this._cent = null;
        this._newValue = null;
        this._onCompleteInc = null;
        this._onStepInc = null;
        this._soundInc = null;
        this._specSymbol = null;
        this._delaySymbol = null;
        this._lastText = null;
        this._firstText = null;

        return super.destroy();
    }

    stopInctAnimation() {
        if (this._tween) {
            this._tween.kill();
            this._tween = null;

            this._value = this._newValue;
            this.createText();
            this.updateNumbers();
        }
    }

    /**     * @public     */
    pauseIncAnim() {
        if (this._tween)
            this._tween.pause();
    }

    /**     * @public     */
    continueIncAnim() {
        if (this._tween)
            this._tween.resume();
    }

    get value() {
        return Number(this._value);
    }

    set specSymbol(value) {
        this._specSymbol = value;
    }

    set zeroZeroType(value) {
        this._zeroZeroType = value;
    }

    set onCompleteInc(value) {
        this._onCompleteInc = value;
    }

    set incSecond(value) {
        this._incSecond = value;
    }

    get incSecond() {
        return this._incSecond;
    }

    set onStepInc(value) {
        this._onStepInc = value;
    }

    set soundInc(value) {
        this._soundInc = value;
    }

    set hideIfZero(isHide) {
        this._hideIfZero = isHide;
        if (isHide && this.value === 0 && this.visible)
            this.visible = false;
    }

    set delaySymbol(value) {
        this._delaySymbol = value;
    }

    /**
     * @returns {*|boolean}
     */
    get checkFontSize() {
        return this._checkFontSize;
    }

    /**
     * @param value
     */
    set checkFontSize(value) {
        this._checkFontSize = value;
    }

    set simpleZero(value) {
        this._simpleZero = value;
    }

    set lastText(value) {
        this._lastText = value;
    }

    set firstText(value) {
        this._firstText = value;
    }

    set showCent(value) {
        this._showCent = value;
    }
}
